<ul class="files-list" [class.compact]="compact">
  <ng-container *ngFor="let file of files">
    <li *cmLet="(file | fileErrors : maxSize : allowedTypes) as error" class="file" [class.warning]="error">
      <div class="file-info">
        <span *ngIf="file.url || file.link" (click)="openFilePreview(file)" class="cm-link cm-link-secondary file-name">{{file.name}}</span>
        <span *ngIf="!file.url && !file.link" class="file-name">{{file.name}}</span>
        <span class="file-size">{{file.size | fileSize}} <span *ngIf="error">- {{error}}</span></span>
        <span *ngIf="showLoadingData && file.updatedAt" class="file-loading-data">{{file.updatedAt | dateFormat: 'dateTime'}}</span>
      </div>
      <button *ngIf="showControls" class="cm-link" type="button" (click)="removeFile.emit(file)">Delete</button>
    </li>
  </ng-container>
</ul>
